$(document).on('click', 'li.product-tags', function(e) {
  e.preventDefault();

  $('li.product-tags').removeClass('active');
  var get_litag = $(this).attr('data-tag-comma');
  $(this).addClass('active');

  // Hide all product-listing elements
  $('.collection-listing .product-listing').hide().removeClass('active-row');
  
  // Show only the elements with matching tags
  $('.collection-listing .product-listing').each(function() {
    var product_tag = $(this).attr('data-tag-comma');
    
    if (product_tag.indexOf(get_litag) !== -1) {
      $(this).addClass('active-row').show();
    }
    
   
  });
});
